import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import React from "react";
import {
  Box,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState} from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { Form, useActionData } from "react-router-dom";
import "src/components/Login/login.css";

import useForm from "src/hooks/use-form";

import PersonIcon from "@mui/icons-material/Person";
import LoginValidator from "src/validators/login-validator.ts";

const properties = {
  username: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
   
    icon: <PersonIcon sx={{ marginRight: "10px" }} />,
  },
  password: {
    value: "",
    type: "password",
    isTouched: false,
    hasError: false,

  },
};

const validator = new LoginValidator();

const LoginForm = (props) => {
  const data = useActionData();

  const { inputs, errorMessages } = useForm(validator, properties);

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Form method={props.loginFormMethod}>
      <div className="loginFormContainer">
        <Box
          display={"flex"}
          flexDirection={"column"}
          maxWidth={250}
          height={400}
          alignItems={"center"}
          justifyContent={"center"}
          padding={5}
          borderRadius={5}
          sx={{ background: props.loginFormBackground }}
        >
          {props.isLoginTitle === true ? (
            <Typography variant="h2" padding={3} textAlign={"center"}>
              {props.loginTitle}
            </Typography>
          ) : (
            ""
          )}

          {props.isImageForm === true ? (
            <Box sx={{ padding: props.imageFormPadding, textAlign: "center" }}>
              <img
                alt={"dgd"}
                src={props.imageForm}
                style={{ width: props.imageFormWidth }}
              ></img>
            </Box>
          ) : (
            ""
          )}

          {data && data.message && <p style={{ color: "red" }}>{data.message}</p>}

          {Object.entries(inputs).map((element, k) => (
            <Box
              key={element[0] + k}
              sx={{
                width: props.widthContainerFieldLoginForm,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              marginBottom={2}
            >
             
              {
                
                <TextField
                
                  InputLabelProps={{
                    style: {
                      color: props.loginFormLabelColor,
                      fontSize: "16px",
                      marginLeft: "10px",
                      borderBottom: 0,
                    },
                    shrink: true,
                  }}
                  id={element[0]}
                  name={element[0]}
                  value={element[1].value}
                  onChange={element[1].valueChangeHandler}
                  onBlur={element[1].inputBlurHandler}
                  error={element[1].hasError}
                  helperText={
                    element[1].hasError && errorMessages[element[0]]
                  }
                  margin={"normal"}
                  type={
                    element[1].type === "password"
                      ? showPassword
                        ? "text"
                        : "password"
                      : element[1].type
                  }
                  size={"small"}
                  InputProps={
                    element[0] === "password"
                      ? {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              sx={{ marginRight: "10px", color: "white" }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                        style: { color: "white" },
                      }
                      : { style: { color: "white" } }
                  }
                  variant={"standard"}
                  placeholder={element[1].placeholder}
                  sx={{
                    width: "100%",
                    padding: "2px",
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid grey",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "3px solid #3232f9",
                    },
                    "& .MuiInput-underline:hover": {
                      borderBottom: "1px solid grey",
                    },
                  }}
                />
                // )
              }
            </Box>
          ))}

          <div className="loginButton">
            <ButtonPolicy
              sx={{
                marginTop: 3,
                borderRadius: 3,
                width: "100%",
                backgroundColor: props.loginFieldBackground,
                color: "#fff",
                ":hover": { backgroundColor: props.loginFieldBackground },
              }}
              variant={"container"}
              color={"primary"}
              //   onClick={handleSubmit}
              type={"submit"}
            >
              {props.textLoginButton}
            </ButtonPolicy>

          </div>


        </Box>
      </div>
    </Form>
  );
};

LoginForm.defaultProps = {
  fieldLoginForm: [],
  imageFormPadding: "10% 0",
  imageFormWidth: "40%",
  loginFieldBackground: "#616060",
  loginFormColor: "white",
  loginFormBackground: "black",
  loginFormLabelColor: "rgb(230, 230, 230)",
  widthContainerFieldLoginForm: "100%",
  loginFormMethod: "POST",
  textLoginButton: "LOGIN",
  loginFormOnClickButton: () => { },
};

LoginForm.propTypes = {
  fieldLoginForm: PropTypes.array.isRequired,
  loginTitle: PropTypes.string,
  imageForm: PropTypes.string,
  imageFormWidth: PropTypes.string,
  isLoginTitle: PropTypes.bool,
  isImageForm: PropTypes.bool,
  imageFormPadding: PropTypes.string,
  loginFieldBackground: PropTypes.string,
  loginFormColor: PropTypes.string,
  loginFormBackground: PropTypes.string,
  loginFormLabelColor: PropTypes.string,
  widthContainerFieldLoginForm: PropTypes.string,
  loginFormMethod: PropTypes.string,
  loginFormAction: PropTypes.string,
  textLoginButton: PropTypes.string,
  loginFormOnClickButton: PropTypes.func,
};

export default LoginForm;
